import React from 'react'
import Sidebar from "../Common/Sidebar";
import Header from "../Common/Header";
import Withdraw from './Withdraw'



export default function index() {
    return (
        <div>
            <div className=" hidden xl:block" >
                <Sidebar />
            </div>

            <div className=" xl:ml-[270px]   ">
                <Header />
                <Withdraw />
            </div>

        </div>
    )
}